import $ from "jquery/dist/jquery";
import "select2";
import { b64Uri, getData, readTranslations, setSelect2Ajax } from "../helpers";

export class SelectDos {
    #select = null;
    #placeholder = "view.plugins.select2.placeholder";
    #noResults = "view.plugins.select2.noResults";
    #searching = "view.plugins.select2.searching";
    #clear = "view.plugins.select2.clear";

    #configSelect2 = {
        theme: "Bootstrap5",
        placeholder: "Elige una opción...",
        width: "100%",
        language: {
            noResults: () => "No se encontraron resultado",
            searching: () => "Buscando...",
            clear: "Limpiar selección",
        },
    };

    constructor(object = {}) {
        this.#configSelect2 = { ...this.#configSelect2, ...object };
    }

    async selectDos(select) {
        this.#select = select;
        // Comienza desde el elemento select y sube hacia los Parents
        let parent = select;

        while (parent) {
            // Sigue subiendo hasta encontrar el modal
            parent = parent.parentElement;
            if (parent?.classList.contains("modal")) {
                break;
            }
        }

        if (parent) {
            this.#configSelect2.dropdownParent = $(parent);
        }

        // Traducir
        const Translations = await readTranslations(getData("html", "lang"));

        if (this.#configSelect2.placeholder) {
            this.#configSelect2.placeholder = Translations[this.#placeholder];
        }

        if (!this.#configSelect2.language) {
            this.#configSelect2.language = {};
        }

        this.#configSelect2.language.noResults = () =>
            Translations[this.#noResults];
        this.#configSelect2.language.searching = () =>
            Translations[this.#searching];
        this.#configSelect2.language.clear = Translations[this.#clear];

        let s = $(select)
            .select2(this.#configSelect2)
            .on("change", (e) => {
                // Este evento es predeterminado de los navegadores
                this.#select.setAttribute(
                    "data-data-selected",
                    b64Uri($(select).select2("data")[0])
                );

                // Este evento es predeterminado de los navegadores por lo que es útil tenelo;
                // crear evento Personalizado
                const CE = new CustomEvent("aj:change", {
                    detail: { data: $(select).select2("data")[0] },
                    bubbles: true,
                    cancelable: true,
                });

                select.dispatchEvent(CE);
            })
            .on("select2:select", (e) => {
                this.#select.setAttribute(
                    "data-data-selected",
                    b64Uri(e.params.data)
                );

                // crear el mismo evento
                const CE = new CustomEvent("aj:select2", {
                    detail: e.params,
                    bubbles: true,
                    cancelable: true,
                });

                select.dispatchEvent(CE);

                // utilizar el CE.defaultPrevented para detener el evento en caso de utilizae preventDefault()
            });

        return s;
    }

    default(data) {
        if (data.id) {
            setSelect2Ajax(this.#select, data.id, data.text);
        }
    }
}
